import { UserProfile } from "@/types/user.types";

import { useAppReady } from "./use-app-ready";
import useHasNoPermission from "./use-check-permissions";

/**
 * Hook que combina verificação de permissões com estado de carregamento da aplicação
 * Garante que botões só sejam liberados quando TODOS os dados estão carregados
 * Segue a mesma lógica do projeto Next.js
 * @param requiredProfiles - Perfis necessários para a funcionalidade
 * @returns boolean - true se não tem permissão OU se ainda está carregando
 */
export const useButtonPermission = (requiredProfiles: UserProfile[]) => {
  const hasNoPermission = useHasNoPermission(requiredProfiles);
  const { isReady } = useAppReady();

  // Botão fica desabilitado se:
  // 1. Ainda está carregando dados (app não ready)
  // 2. Usuário não tem permissão
  const shouldDisableButton = !isReady || hasNoPermission;

  return {
    disabled: shouldDisableButton,
    isReady,
    hasNoPermission,
    loading: !isReady,
  };
};

export default useButtonPermission;
